module.exports = __WEBPACK_EXTERNAL_MODULE_155__;


//////////////////
// WEBPACK FOOTER
// external "package-json"
// module id = 155
// module chunks = 0